import { useState } from "react";
import { useTour } from "@/contexts/useTour";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Compass } from "lucide-react";

export function TourOfferModal() {
  const { shouldShowOffer, dismissOffer, acceptOffer } = useTour();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <Dialog open={shouldShowOffer} onOpenChange={(open) => { if (!open) dismissOffer(dontShowAgain); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center items-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <Compass className="h-7 w-7 text-primary" />
          </div>
          <DialogTitle className="text-xl font-bold">Welcome to Redefining Normal{"\u2122"}</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground mt-2">
            Would you like a quick guided tour? We'll walk you through the key features
            of the research platform in about 2 minutes.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex flex-col gap-4 sm:flex-col">
          <div className="flex gap-3 w-full">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => dismissOffer(dontShowAgain)}
            >
              No Thanks
            </Button>
            <Button
              className="flex-1"
              onClick={acceptOffer}
            >
              Yes, Show Me Around
            </Button>
          </div>
          <div className="flex items-center gap-2 justify-center">
            <Checkbox
              id="tour-dismiss"
              checked={dontShowAgain}
              onCheckedChange={(checked) => setDontShowAgain(checked === true)}
            />
            <label
              htmlFor="tour-dismiss"
              className="text-xs text-muted-foreground cursor-pointer select-none"
            >
              Don't show this again
            </label>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
